function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.57,21.06H21.78l.15-.83h1.33A3.28,3.28,0,0,0,26.57,17h0v-.83a2.47,2.47,0,0,0-2.47-2.47h-1l.12-.67a.83.83,0,0,0-.63-1H9.33a.81.81,0,0,0-.63.3.77.77,0,0,0-.18.68L10,21.1H5.2m18.93-5.74a.82.82,0,0,1,.83.8v0h0V17a1.65,1.65,0,0,1-1.65,1.65H22.24l.61-3.28ZM10.29,13.64H21.47L20.13,21H11.62Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.63,12.46a1.18,1.18,0,0,1,1.31-.12.79.79,0,0,1,.19-.22,2.36,2.36,0,0,0,.54-1.77,3.78,3.78,0,0,0-1.1-1.85c-.66-.75-1-1.2-.74-1.81a.45.45,0,0,0-.09-.58.46.46,0,0,0-.6,0c-2.1,2.08-1,3.45-.14,4.45l.4.51a1,1,0,0,1,.22.34,1.06,1.06,0,0,1,.12.74",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.21,12.18h0a2.38,2.38,0,0,0,.58-1.82,3.7,3.7,0,0,0-1.1-1.85c-.66-.75-1-1.2-.7-1.81a.45.45,0,0,0-.13-.58.44.44,0,0,0-.59,0c-2.13,2.08-1,3.45-.18,4.44.53.63.84,1.06.74,1.56h0l.06.09a1.17,1.17,0,0,1,.74-.07,4.93,4.93,0,0,0,.54,0Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75,21.06H5.33a.82.82,0,1,0,0,1.64H6.62l2.17,2.37.1.11a4.3,4.3,0,0,0,2.47.82h9.35a4.28,4.28,0,0,0,2.47-.82l.1-.11,2.17-2.36h1.3a.83.83,0,0,0,.74-.9A.81.81,0,0,0,26.75,21.06Z",
    style: {
      fill: "#7c7c7c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceBreak);
export default __webpack_public_path__ + "static/media/presence-break.fd6f3043.svg";
export { ForwardRef as ReactComponent };